package com.hyperether.goodjob.scenes.user

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Card
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import androidx.navigation.NavHostController
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.Sp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.User
import com.hyperether.goodjob.models.UserStatus
import com.hyperether.goodjob.navigation.AddNewUser
import com.hyperether.goodjob.repository.remote.model.WorkingHours
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.admin
import com.hyperether.goodjob.resources.details
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.resources.employee
import com.hyperether.goodjob.resources.employee_details
import com.hyperether.goodjob.resources.employment_details
import com.hyperether.goodjob.resources.leave_details
import com.hyperether.goodjob.resources.manager
import com.hyperether.goodjob.resources.no_dates_selected
import com.hyperether.goodjob.resources.no_hours_available
import com.hyperether.goodjob.resources.not_assigned
import com.hyperether.goodjob.resources.skills
import com.hyperether.goodjob.resources.team
import com.hyperether.goodjob.resources.user_status_active
import com.hyperether.goodjob.resources.user_status_inactive
import com.hyperether.goodjob.resources.user_status_pending
import com.hyperether.goodjob.scenes.components.CircleWithInitialUser
import com.hyperether.goodjob.scenes.components.MobileHeaderBackAndAction
import com.hyperether.goodjob.scenes.components.UserContacts
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.DateTimeUtil.formatWorkingHoursText
import com.hyperether.goodjob.util.DateTimeUtil.groupContiguousWorkingHours
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun UserDetailsScreen(
    userId: String,
    isMobileView: Boolean,
    viewModel: UserViewModel,
    navController: NavHostController,
    boxWidth: androidx.compose.ui.unit.Dp
) {
    viewModel.roleMap = mapOf(
        stringResource(Res.string.admin) to Role.admin.name,
        stringResource(Res.string.manager) to Role.manager.name,
        stringResource(Res.string.employee) to Role.employee.name,
    )
    viewModel.userStatusMap = mapOf(
        stringResource(Res.string.user_status_active) to UserStatus.active.name,
        stringResource(Res.string.user_status_pending) to UserStatus.pending.name,
        stringResource(Res.string.user_status_inactive) to UserStatus.inactive.name,
    )

    // Refresh user data on every entrance. TODO: optimize this
    LaunchedEffect(Unit) {
        if (isMobileView)
            viewModel.loadRemoteData()
    }

    if (isMobileView) {
        val users by viewModel.users.collectAsState(emptyList())
        val user = users.find { it._id == userId }

        println(user.toString())

        Box(modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .disableMouseDragScrollOnWeb()) {
            Column {
                MobileHeaderBackAndAction(
                    title = stringResource(Res.string.employee_details),
                    back = { navController.navigateUp() },
                    actionEnabled = viewModel.isDetailsView.value
                ) {
                    Image(
                        painter = painterResource(Res.drawable.edit),
                        contentDescription = "",
                        modifier = Modifier
                            .padding(end = Dp(16f))
                            .clickable(
                                interactionSource = remember { MutableInteractionSource() },
                                indication = null
                            ) {
                                if (user != null) {
                                    if (getPlatformChecker().isMobile()) {
                                        navController.navigate(AddNewUser(user._id ?: ""))
                                    } else {
                                        navController.navigate(AddNewUser(user._id ?: ""))
                                    }
                                }
                            }
                    )
                }

                Column(
                    modifier = Modifier
                        .background(Color.LightGray.copy(alpha = 0.2f))
                        .padding(Dp(8f)),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Row(
                        modifier = Modifier.fillMaxWidth().height(Dp(40f)),
                        //TODO remove this when return daily activities
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.CenterVertically
                    ) {

                        androidx.compose.material3.Text(
                            text = stringResource(Res.string.details),
                            color = if (viewModel.isDetailsView.value) BlueApp else Color.Gray,
                            fontSize = Sp(16f),
                            modifier = Modifier
                                // .padding(start = Dp(40f))
                                .clickable(
                                    interactionSource = remember { MutableInteractionSource() },
                                    indication = null
                                ) {
                                    viewModel.isDetailsView.value = true
                                },
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
//
//                        Spacer(modifier = Modifier.weight(0.5f))
//
//                        androidx.compose.material3.Text(
//                            text = stringResource(Res.string.daily_activities),
//                            color = if (viewModel.isDetailsView.value) Color.Gray else BlueApp,
//                            fontSize = Sp(16f),
//                            modifier = Modifier
//                                .padding(end = Dp(40f))
//                                .clickable(
//                                interactionSource = remember { MutableInteractionSource() },
//                                indication = null
//                            ) {
//                                    viewModel.isDetailsView.value = false
//                                }
//                        )
                    }
                }
//                Box(
//                    modifier = Modifier
//                        .height(Dp(2f))
//                        .fillMaxWidth(0.5f)
//                        .background(if (viewModel.isDetailsView.value) BlueApp else BlueApp)
//                        .align(if (viewModel.isDetailsView.value) Alignment.Start else Alignment.End)
//                )
                if (viewModel.isDetailsView.value) {
                    UserHeader(user, viewModel)
                    UserContacts(isProfileView = false, user = user)
                    UserDetails(user)
                    UserLeaveDetails(user)
                }
            }
        }
    } else {
        SelectionContainer {
            UserDetailsScreenWeb(
                userId = userId,
                viewModel = viewModel,
                navController = navController,
            boxWidth = boxWidth)
        }
    }
}


@Composable
fun UserHeader(user: User?, viewModel: UserViewModel) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = Dp(16f), end = Dp(16f), top = Dp(20f), bottom = Dp(5f)),
        shape = RoundedCornerShape(Dp(8f)),
        elevation = Dp(4f)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(start = Dp(16f), end = Dp(16f), top = Dp(20f), bottom = Dp(10f)),
            verticalAlignment = Alignment.CenterVertically
        ) {
//            Image(
//                painter = painterResource(Res.drawable.baseline_person_24),
//                contentDescription = "Rounded Image",
//                modifier = Modifier
//                    .size(Dp(50f))
//                    .clip(CircleShape)
//                    .background(Color.LightGray)
//
//            )
            CircleWithInitialUser(user, size = Dp(50f))

            Spacer(modifier = Modifier.width(Dp(16f)))

            Column(
                modifier = Modifier.weight(1f)
            ) {
                user?.getName()?.let {
                    Text(
                        text = it,
                        fontWeight = FontWeight.Bold,
                        fontSize = Sp(14f)
                    )
                }
                user?.role?.let {
                    Text(
                        text = viewModel.roleMap.entries.find { role -> role.value == it }?.key
                            ?: "",
                        color = Color.Gray,
                        fontSize = Sp(14f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }

            Text(
                text = "",
                modifier = Modifier.align(Alignment.CenterVertically),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
fun UserDetails(user: User?) {
    val workingHours: WorkingHours? = user?.workingHours
    val workingHoursText = workingHours?.let {
        val groupedSchedule = groupContiguousWorkingHours(it)
        formatWorkingHoursText(groupedSchedule)
    }

    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = Dp(16f), end = Dp(16f), top = Dp(4f), bottom = Dp(10f)),
        shape = RoundedCornerShape(Dp(8f)),
        elevation = Dp(4f)
    ) {
        Column(modifier = Modifier.padding(Dp(16f))) {
            Text(
                text = stringResource(Res.string.employment_details),
                fontWeight = FontWeight.Bold,
                fontSize = Sp(14f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = if (workingHoursText?.isNotEmpty() == true) workingHoursText else stringResource(
                    Res.string.no_hours_available
                ),
                fontSize = Sp(14f),
                color = Color.Gray,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )

            Text(
                text = buildAnnotatedString {

                    withStyle(
                        style = SpanStyle(
                            fontWeight = FontWeight.W400,
                            color = Color.Gray,
                            fontSize = Sp(14f)
                        )
                    ) {
                        append(stringResource(Res.string.team) + ": ")
                    }
                    withStyle(
                        style = SpanStyle(
                            fontWeight = FontWeight.W400,
                            color = Color.Black,
                            fontSize = Sp(14f)
                        )
                    ) {
                        val teams = user?.teams ?: emptyList()
                        if (teams.isNotEmpty()) {
                            for ((index, team) in teams.withIndex()) {
                                append(team?.value)
                                if (index != teams.size - 1) {
                                    append(", ")
                                }
                            }
                        } else {
                            append(stringResource(Res.string.not_assigned))
                        }
                    }
                }
            )
            Text(
                text = buildAnnotatedString {
                    withStyle(
                        style = SpanStyle(
                            fontWeight = FontWeight.W400,
                            color = Color.Gray,
                            fontSize = Sp(14f)
                        )
                    ) {
                        append(stringResource(Res.string.skills) + ": ")
                    }
                    withStyle(
                        style = SpanStyle(
                            fontWeight = FontWeight.W400,
                            color = Color.Black,
                            fontSize = Sp(14f)
                        )
                    ) {
                        if (user?.skills?.isNotEmpty() == true) {
                            val skills =
                                user.skills?.filter { it.isNotEmpty() }?.joinToString(", ")
                                    ?: stringResource(Res.string.not_assigned)
                            append(skills)
                        } else {
                            append(stringResource(Res.string.not_assigned))
                        }
                    }
                },
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

@Composable
fun UserLeaveDetails(user: User?) {
    val leaveString = if (user?.upcomingLeave?.isNotEmpty() == true)
        DateTimeUtil.formatDateRange(user.upcomingLeave)
            ?: stringResource(Res.string.no_dates_selected)
    else
        stringResource(Res.string.no_dates_selected)
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = Dp(16f), end = Dp(16f), top = Dp(10f), bottom = Dp(10f)),
        shape = RoundedCornerShape(Dp(8f)),
        elevation = Dp(4f)
    ) {
        Column(modifier = Modifier.padding(Dp(16f))) {
            Text(
                text = stringResource(Res.string.leave_details),
                fontWeight = FontWeight.Bold,
                fontSize = Sp(14f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Text(
                text = leaveString,
                fontSize = Sp(14f),
                color = Color.Gray,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}
